import type { ApiConfig } from '../../types'

export const fundingHistoryApiConfig = {
  existSubType: false,
  fetchableRange: undefined,
  limit: 500,
  order: 'asc',
  range: undefined,
  requiresRange: true,
  type: 'funding-history',
} as const satisfies ApiConfig
